import classNames from 'classnames';
import { useId } from 'react';
import { Trans } from 'react-i18next';

import { AlertInfoIcon, Tooltip } from '@ctct/payflow-ui';

import type { FooterItemProps } from '../types';

const tooltipTranslationComponents = {
  // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid
  Link: <a />,
};

export const SingleFooterItem = ({ label, variant, priceLabel, tooltipI18nKey }: Omit<FooterItemProps, 'id'>) => {
  const outputId = useId();

  return (
    <div className={classNames('order-summary-container__footer-items_item', variant && `variant-${variant}`)}>
      <label className="footer-items__label" htmlFor={outputId}>
        {tooltipI18nKey ? (
          <Tooltip
            content={<Trans i18nKey={tooltipI18nKey} components={tooltipTranslationComponents} />}
            variant="dark"
            hideArrow
          >
            <AlertInfoIcon className="footer-items__info" />
          </Tooltip>
        ) : null}
        <span>{label}</span>
      </label>
      <output className="footer-items__price-label" id={outputId}>
        {priceLabel}
      </output>
    </div>
  );
};
